//export { Base64, toBase64, isBase64, fromBase64 } from "./utils/Base64";

import { Base64, toBase64, isBase64, fromBase64 } from "./utils/Base64";

export type {Base64}

class BioNet {
    
    public utils = {
        toBase64 : toBase64,
        isBase64 : isBase64,
        fromBase64 : fromBase64
    }

    constructor() {}

    test() {
        let message: string = 'Hello World';
        console.log("original:"+message);
    
        const base64String: Base64 = this.utils.toBase64(message);
        console.log("base64String:"+base64String);

        if (this.utils.isBase64(base64String)) {
            console.log("This is a valid Base64 string");
        } else {
            console.log("This is not a valid Base64 string.");
        }
    
        const decoded: string = this.utils.fromBase64(base64String);
        console.log("decoded:"+decoded);
    }
}
const bionet = new BioNet();
export {bionet};

